<div class="client-profile">
  <header class="client-profile__header">
    <div class="client-profile__identity">
      <span class="client-profile__avatar" aria-hidden="true">{{ (client?.client?.fullname || '?').charAt(0) }}</span>
      <div>
        <span class="client-profile__eyebrow">{{ 'hx.client-edit-modal.changeProfile' | transloco }}</span>
        <h2>{{ client?.client?.fullname || ('hx.client-list.noName' | transloco) }}</h2>
        <p>{{ client?.client?.phone || ('hx.client-list.noPhone' | transloco) }}</p>
      </div>
    </div>
    <button type="button" class="client-profile__close" (click)="activeModal.dismiss()" [attr.aria-label]="'hx.btn.cancel' | transloco">×</button>
  </header>
  <nav class="client-profile__tabs" [attr.aria-label]="'hx.client-edit-modal.changeProfile' | transloco">
    <button type="button" [class.is-active]="tab === 'profile'" (click)="changeTab('profile')">{{ 'hx.client-edit.client' | transloco }}</button>
    <button type="button" [class.is-active]="tab === 'brand'" (click)="changeTab('brand')">{{ 'hx.client-edit.info' | transloco }}</button>
    <button type="button" [class.is-active]="tab === 'coins'" (click)="changeTab('coins')">{{ 'hx.client-edit.coins' | transloco }}</button>
    <button type="button" [class.is-active]="tab === 'comments'" (click)="changeTab('comments')">{{ 'hx.client-edit.comment.title' | transloco }}</button>
  </nav>
  <div class="client-profile__body">
    <div *ngIf="loading || sectionLoading" class="client-profile__state">{{ 'hx.client-list.loading' | transloco }}</div>
    <div *ngIf="error" class="client-profile__state" role="alert">
      {{ 'hx.client-list.loadError' | transloco }}
      <button type="button" (click)="load()">{{ 'hx.client-list.retry' | transloco }}</button>
    </div>
    <ng-container *ngIf="!loading && !sectionLoading && !error && client">
      <div *ngIf="tab === 'profile'" class="client-profile__section">
        <div class="client-profile__section-heading">
          <h3>{{ 'hx.client-edit.client' | transloco }}</h3>
          <span *ngIf="client.country">{{ client.country.title | uiLabel }}</span>
        </div>
        <div class="client-profile__form-grid">
          <div *ngIf="!client.country" class="client-profile__field client-profile__field--wide" ngbDropdown #profileCountryMenu="ngbDropdown">
            <span>{{ 'hx.client-list.filter.country' | transloco }}</span>
            <button type="button" class="client-profile__select" ngbDropdownToggle>
              {{ (selectedCountry?.title | uiLabel) || ('hx.client-list.filter.country' | transloco) }}
            </button>
            <div class="client-profile__brand-menu" ngbDropdownMenu>
              <button type="button" *ngFor="let country of countries" (click)="client.client.countryId = country.id; profileCountryMenu.close()">{{ country.title | uiLabel }}</button>
            </div>
          </div>
          <label class="client-profile__field client-profile__field--wide">
            <span>{{ 'hx.client-edit.name' | transloco }}</span>
            <input type="text" [(ngModel)]="client.client.fullname" autocomplete="name">
          </label>
          <label class="client-profile__field">
            <span>{{ 'hx.client-edit.num' | transloco }}</span>
            <input *ngIf="hasStoredPhone" type="tel" [value]="client.client.phone" readonly>
            <input *ngIf="!hasStoredPhone" type="tel" inputmode="tel" [(ngModel)]="client.client.phone"
                   [prefix]="selectedCountry?.phonePrefix || ''" [mask]="selectedCountry?.phoneMask || ''" [patterns]="phonePatterns"
                   [showMaskTyped]="true" [placeholder]="'hx.client-profile.phonePlaceholder' | transloco">
          </label>
          <div class="client-profile__field client-profile__birthday">
            <span>{{ 'hx.client-edit.happyDay' | transloco }}</span>
            <button type="button" class="client-profile__date-button" [attr.aria-expanded]="calendarOpen"
                    (click)="toggleCalendar()">
              <span>{{ client.client.birthDate ? (client.client.birthDate | date: 'dd.MM.yyyy') : ('hx.client-profile.chooseDate' | transloco) }}</span>
              <i class="la la-calendar" aria-hidden="true"></i>
            </button>
          </div>
          <div *ngIf="calendarOpen" class="client-profile__calendar">
            <div class="client-profile__calendar-heading">
              <button type="button" (click)="shiftCalendarMonth(-1)" [attr.aria-label]="'hx.client-profile.previousMonth' | transloco">‹</button>
              <strong>{{ calendarTitle }}</strong>
              <button type="button" (click)="shiftCalendarMonth(1)" [attr.aria-label]="'hx.client-profile.nextMonth' | transloco">›</button>
            </div>
            <label class="client-profile__calendar-year">
              <span>{{ 'hx.client-profile.year' | transloco }}</span>
              <input type="number" [ngModel]="calendarYear" (ngModelChange)="setCalendarYear($event)" min="1900" [max]="calendarMaxYear" inputmode="numeric">
            </label>
            <div class="client-profile__calendar-grid">
              <span *ngFor="let weekday of calendarWeekdays" class="client-profile__weekday">{{ weekday }}</span>
              <ng-container *ngFor="let day of calendarDays">
                <span *ngIf="!day.day"></span>
                <button *ngIf="day.day" type="button" [disabled]="day.disabled" [class.is-selected]="client.client.birthDate === day.date"
                        (click)="selectBirthDate(day.date)">{{ day.day }}</button>
              </ng-container>
            </div>
            <button type="button" class="client-profile__calendar-clear" (click)="selectBirthDate()">{{ 'hx.client-profile.clearDate' | transloco }}</button>
          </div>
          <label *ngIf="birthDateChanged && originalBirthDate" class="client-profile__field client-profile__field--wide">
            <span>{{ 'hx.client-edit.comment.title' | transloco }} *</span>
            <textarea [(ngModel)]="comment" rows="2"></textarea>
          </label>
        </div>
        <div class="client-profile__contacts">
          <div class="client-profile__section-heading">
            <h3>{{ 'hx.client-profile.contacts' | transloco }}</h3>
            <div class="client-profile__contact-actions">
              <button type="button" (click)="addContact('EMAIL')">+ Email</button>
              <button type="button" (click)="addContact('PHONE')">+ {{ 'hx.client-edit.mobileNumber' | transloco }}</button>
            </div>
          </div>
          <div *ngFor="let contact of contacts; let index = index" class="client-profile__contact-row">
            <span>{{ contact.type === 'EMAIL' ? 'Email' : ('hx.client-edit.mobileNumber' | transloco) }}</span>
            <input *ngIf="contact.type === 'PHONE'" type="tel" inputmode="tel" [(ngModel)]="contact.value"
                   [prefix]="selectedCountry?.phonePrefix || ''" [mask]="selectedCountry?.phoneMask || ''" [patterns]="phonePatterns"
                   [showMaskTyped]="true" [class.is-invalid]="!isValidContact(contact)">
            <input *ngIf="contact.type === 'EMAIL'" type="email" inputmode="email" autocomplete="email" maxlength="254"
                   placeholder="name@example.com" [(ngModel)]="contact.value" [class.is-invalid]="!isValidContact(contact)">
            <button type="button" (click)="removeContact(index)" [attr.aria-label]="'hx.client-edit.ng.deleteContact' | transloco">×</button>
            <small *ngIf="!isValidContact(contact)" class="client-profile__contact-error">
              {{ (contact.type === 'EMAIL' ? 'hx.client-profile.invalidEmail' : 'hx.client-profile.invalidPhone') | transloco }}
            </small>
          </div>
          <p *ngIf="!contacts.length" class="client-profile__muted">{{ 'hx.client-profile.noContacts' | transloco }}</p>
        </div>
      </div>

      <div *ngIf="tab === 'brand'" class="client-profile__section">
        <div class="client-profile__section-heading">
          <h3>{{ 'hx.client-edit.info' | transloco }}</h3>
          <button type="button" class="client-profile__light-button" (click)="editProperty()">+ {{ 'hx.client-edit.btn.addNote' | transloco }}</button>
        </div>
        <div *ngFor="let property of properties" class="client-profile__property">
          <div><strong>{{ property.brandTitle }}</strong><p>{{ property.note || '—' }}</p>
            <span *ngIf="property.vip" class="client-profile__badge">VIP</span>
            <span *ngIf="property.blacklisted" class="client-profile__badge client-profile__badge--warning">{{ 'hx.client-edit.table.body.blacklist' | transloco }}</span>
          </div>
          <div class="client-profile__property-actions">
            <button type="button" (click)="editProperty(property)">{{ 'hx.client-edit.ng.change' | transloco }}</button>
            <button type="button" (click)="removeProperty(property)">{{ 'hx.client-edit.ng.delete' | transloco }}</button>
          </div>
        </div>
        <p *ngIf="!properties.length && !propertyDraft" class="client-profile__muted">{{ 'hx.client-profile.noProperties' | transloco }}</p>
        <div *ngIf="propertyDraft" class="client-profile__property-form">
          <div class="client-profile__field" ngbDropdown #propertyBrandMenu="ngbDropdown">
            <span>{{ 'hx.client-edit.table.head.brand' | transloco }}</span>
            <button type="button" class="client-profile__select" ngbDropdownToggle [disabled]="!!propertyDraft.id">
              {{ draftBrandTitle }}
            </button>
            <div class="client-profile__brand-menu" ngbDropdownMenu>
              <button type="button" *ngFor="let brand of brands" (click)="propertyDraft.brandId = brand.id; propertyBrandMenu.close()">{{ brand.title }}</button>
            </div>
          </div>
          <label class="client-profile__check"><input type="checkbox" [(ngModel)]="propertyDraft.vip"> VIP</label>
          <label class="client-profile__check"><input type="checkbox" [(ngModel)]="propertyDraft.blacklisted"> {{ 'hx.client-edit.table.head.blacklist' | transloco }}</label>
          <label class="client-profile__field client-profile__field--wide"><span>{{ 'hx.client-edit.table.head.note' | transloco }}</span>
            <textarea [(ngModel)]="propertyDraft.note" rows="3"></textarea>
          </label>
          <div class="client-profile__inline-actions">
            <button type="button" class="client-profile__primary" (click)="saveProperty()" [disabled]="saving">{{ 'hx.btn.save' | transloco }}</button>
            <button type="button" class="client-profile__light-button" (click)="propertyDraft = undefined">{{ 'hx.btn.cancel' | transloco }}</button>
          </div>
        </div>
      </div>

      <div *ngIf="tab === 'coins'" class="client-profile__section">
        <div class="client-profile__section-heading"><h3>{{ 'hx.client-edit.coins' | transloco }}</h3></div>
        <div class="client-profile__coin-scope">
          <div class="client-profile__field" ngbDropdown #coinBrandMenu="ngbDropdown">
            <span>{{ 'hx.client-list.filter.brand' | transloco }}</span>
            <button type="button" class="client-profile__select" ngbDropdownToggle>{{ selectedCoinBrand?.title || ('hx.client-list.filter.brand' | transloco) }}</button>
            <div class="client-profile__brand-menu" ngbDropdownMenu>
              <button type="button" *ngFor="let brand of brands" [class.is-selected]="brand.id === coinBrandId"
                      (click)="selectCoinBrand(brand.id); coinBrandMenu.close()">{{ brand.title }}</button>
            </div>
          </div>
          <div class="client-profile__field" ngbDropdown #coinCountryMenu="ngbDropdown">
            <span>{{ 'hx.client-list.filter.country' | transloco }}</span>
            <button type="button" class="client-profile__select" ngbDropdownToggle>{{ (selectedCoinCountry?.title | uiLabel) || ('hx.client-list.filter.country' | transloco) }}</button>
            <div class="client-profile__brand-menu" ngbDropdownMenu>
              <button type="button" *ngFor="let country of countries" [class.is-selected]="country.id === coinCountryId"
                      (click)="selectCoinCountry(country.id); coinCountryMenu.close()">{{ country.title | uiLabel }}</button>
            </div>
          </div>
        </div>
        <div class="client-profile__coin-balance"><span>{{ 'hx.client-edit.activeCoins' | transloco }}</span><strong>{{ activeCoins }}</strong></div>
        <div class="client-profile__coin-table" *ngIf="coins.length">
          <div class="client-profile__coin-head">
            <span>{{ 'hx.client-edit.coin.th.operation' | transloco }}</span>
            <span>{{ 'hx.client-edit.coin.th.amount' | transloco }}</span>
            <span>{{ 'hx.client-edit.coin.th.activationDate' | transloco }}</span>
            <span>{{ 'hx.client-edit.coin.th.expireDate' | transloco }}</span>
          </div>
          <div *ngFor="let coin of coins" class="client-profile__transaction">
            <span class="client-profile__coin-action" [class.is-spent]="coin.action === 'SPENT' || coin.action === 'CANCELLED'">
              {{ ('hx.enum.CoinOperation.' + coin.action) | transloco }}
            </span>
            <strong>{{ coin.amount }}</strong>
            <time>{{ coin.activationDate | date: 'dd.MM.yyyy HH:mm' }}</time>
            <time>{{ coin.expireDate | date: 'dd.MM.yyyy HH:mm' }}</time>
            <a *ngIf="coin.orderId" [routerLink]="'/orders/' + coin.orderId" target="_blank">#{{ coin.orderId }}</a>
          </div>
        </div>
        <p *ngIf="!coins.length" class="client-profile__muted">{{ 'hx.client-profile.noCoins' | transloco }}</p>
        <div class="client-profile__coin-pagination" *ngIf="coins.length && (coinHasNext || coinPage > 1)">
          <span>{{ 'hx.client-profile.page' | transloco: {page: coinPage} }}</span>
          <div>
            <button type="button" [disabled]="coinPage <= 1" (click)="previousCoins()" [attr.aria-label]="'hx.client-profile.previousPage' | transloco">←</button>
            <button type="button" [disabled]="!coinHasNext" (click)="nextCoins()" [attr.aria-label]="'hx.client-profile.nextPage' | transloco">→</button>
          </div>
        </div>
      </div>

      <div *ngIf="tab === 'comments'" class="client-profile__section">
        <div class="client-profile__section-heading"><h3>{{ 'hx.client-edit.comment.title' | transloco }}</h3></div>
        <div *ngFor="let item of comments" class="client-profile__comment">
          <p>{{ item.text }}</p><span>{{ item.actorFullName }} · {{ item.date | date: 'dd.MM.yyyy HH:mm' }}</span>
        </div>
        <p *ngIf="!comments.length" class="client-profile__muted">{{ 'hx.client-profile.noComments' | transloco }}</p>
      </div>
    </ng-container>
  </div>
  <footer class="client-profile__footer">
    <button type="button" class="client-profile__light-button" (click)="activeModal.dismiss()">{{ 'hx.btn.cancel' | transloco }}</button>
    <button *ngIf="tab === 'profile'" type="button" class="client-profile__primary" (click)="save()" [disabled]="saving || loading || error">
      {{ 'hx.btn.save' | transloco }}
    </button>
  </footer>
</div>
